<template>
  <div class="container">
    <mt-header fixed title="修改头像" class="head" >
      <router-link to="/account" slot="left">
        <mt-button icon='back'></mt-button>
      </router-link>
      <mt-button slot="right" @click="commit">保存</mt-button>
    </mt-header>
    <div class="procedure">
      <div class="procedure-group">
        <!--<div class="procedure-title">上传照片</div>-->
        <div class="procedure-content c_flex c_between bg_white c_m_t_10">
          <div class="c_flex c_flex_1 c_item_center ">头像</div>
          <div class="c_rela  procedure-img">
            <img :src="qiniu+img +'?imageView2/1/w/100/h/100'" :data-src="qiniu + img" @click="imgShowClick" class="" v-show="img?true:false" />
            <div class="img-file" :class="img?'c_opacity_0':''">
              <update-file v-show="img?false:true" type="all" nowater="true" @fileChange="getUrl($event,'avatar')"></update-file>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import UpdateFile from './update-file';
  import CImgshow from './c-imgshow';
  export default {
    components:{UpdateFile,CImgshow},
    name: "avatar",
    data:function () {
      return {
        qiniu:this.$$api.mobile.qiniuDownload,
        img:'',
        // 图片显示
        ispart_imgshow:false,
        imgshow_url:'',
      }
    },
    mounted:function () {
      let img = this.$route.params.img;
      this.img = img;
    },
    methods:{
      getUrl(e,val){
        var $that = this;
        // var file = e.files[0];
        var file = this.$comm.toBase64(e.base64);
        if(val=='avatar'){
          this.imgFile('avatar',file,function (url) {
            $that.img = url;
            $that.$indicator.close();
          });
        }
      },
      // 上传图片
      imgFile:function(type,file,fun){
        var $that = this;
        $that.$indicator.open();
        this.$ajax.get(this.$$api.mobile.getimgtoken,{},function (res) {
          if(res.status == 200){
            var token = res.data.token;
            var fileid = res.data.fileid;
            let param = new FormData(); //创建form对象
            param.append('file',file,file.name);//通过append向form对象添加数据
            param.append('chunk','0');//添加form表单中其他数据
            param.append('token',token);//添加form表单中其他数据
            param.append('key',fileid);//添加form表单中其他数据
            let config = {
              headers:{'Content-Type':'multipart/form-data'}
            };
            axios.post($that.$$api.mobile.qiniuUpload,param,config)
              .then(data=>{
                var key = data.data.key;
                if(fun)fun(key);
                // $that.$indicator.close();
              });
          }
        });

      },

      commit:function () {
        var $that = this;
        this.$ajax.post(this.$$api.mobile.editUserInfo,{
          type:'photo',
          data:$that.img
        },function (res) {
          var obj = JSON.parse(localStorage['userinfo'])||{};
          obj.avatar = $that.img;
          localStorage['userinfo'] = JSON.stringify(obj);
          $that.$router.push('/account');
        });
      },
      // 图片预览
      imgShowClick:function (e) {
        var url = e.currentTarget.dataset.src;
        if(url){
          this.imgshow_url = url;
          this.ispart_imgshow = true;
        }
      },
    }
  }
</script>

<style scoped>
  .img-file{
    position: absolute;
    z-index: 10;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .c_opacity_0{
    opacity: 0;
  }
  .procedure-add{
    display: block !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/avatar.vue